import { twMerge } from "tailwind-merge";

function MainDiv({ children, className = "", style = {}, from = "table" }) {
  let padding = "mt-5 mb-2 px-4 py-4 h-full ";
  if (from == "form") {
    // contains form cards
    padding = "p-[30px] h-auto";
  } else if (from == "tablecard") {
    // contains form cards
    padding = "px-4 py-4 h-auto";
  }
  const classname = twMerge(
    `w-full rounded-md bg-white text-black dark:bg-black dark:text-white dark:border-white dark:border ${padding}`,
    // "w-full mt-5 mb-2 px-4 py-4 bg-black text-white",
    className
  );

  return (
    <div
      className={classname}
      // style={{ boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.2)", ...style }}
      style={{ boxShadow: "rgba(0, 0, 0, 0.10) 0px 3px 15px", ...style }}
      // style={{ boxShadow: "0px 2px 8px rgba(255, 255, 255, 0.3)", ...style }}
    >
      {children}
    </div>
  );
}
export default MainDiv;
